import React from "react";
import NavBar from "../components/NavBar/navBar.component";
import Footer from "../components/Footer/footer.component";
import RefundPolicyHero from "../components/RefundPolicy/refundPolicy.component";

function RefundPolicy() {
  return (
    <div>
      <NavBar />
      <RefundPolicyHero/>
      <Footer />
    </div>
  );
}

export default RefundPolicy;
